<div class="sidemenu-header-container">
  <div class="sidemenu-header-avatar">
  </div>
  <div class="sidemenu-header-info"> 
    <ion-label>{{business?.name }}</ion-label>
    <ion-label class="user-name">{{ user?.email }}</ion-label>
  </div>
</div>
